import "./Header.css";

import { HiOutlineBars3 } from "react-icons/hi2";
import { useLocation } from "react-router-dom";

import { useAppSelector } from "../../../../_store";
// import { ThemeToggle } from "../ThemeToggle";
import {
  //  NotificationDropdown,
  ProfileDropdown,
} from "./_components";
import { getHeaderTitle } from "./Header.utils";

interface HeaderProps {
  setDrawer: (value: boolean) => void;
}
export const Header = ({ setDrawer }: HeaderProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const { pathname } = useLocation();

  if (!user) return null;

  return (
    <header className="userHeader">
      <div className="userHeaderLeft">
        <HiOutlineBars3
          size={18}
          className="menuIcon"
          onClick={() => setDrawer(true)}
        />
        <h2>{getHeaderTitle(pathname)}</h2>
      </div>

      <div className="userHeaderRight">
        {/* <ThemeToggle /> */}

        {/* <NotificationDropdown /> */}

        <ProfileDropdown />
      </div>
    </header>
  );
};
